import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import OkButton from '../atoms/OkButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    message,
    idShopShow
  }) => {
    const actionChage = id => {
      changeAction(id);
    };
    return (
      <Dialog
        open={openChangeConfirm}
        onClose={() => {
          updateOpenChangeConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <OkButton onClickAction={() => actionChage(idShopShow)} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
